export default "__VITE_ASSET__CS0$GcQG__"